import { SignUpMethod } from '~/types/SignUpMethod';
import { analytics } from './useLoadSegment';
import { ID } from '@segment/analytics-next';

export const SIGNUP_ACTIONED_EVENT = 'Sign Up Actioned';
const SIGNUP_ACTIONED_STEP = 'authOptions';

type SignUpActioned =
  | {
      action: 'viewed';
      anonymousId: ID;
      selection?: never;
    }
  | {
      action: 'submitted';
      anonymousId: ID;
      selection: SignUpMethod;
    };

export function fireSignUpActioned({ action, anonymousId, selection }: SignUpActioned) {
  analytics.track(SIGNUP_ACTIONED_EVENT, {
    action,
    anonymousId,
    selection,
    step: SIGNUP_ACTIONED_STEP,
  });
}

export async function fireSignUpSuccess({
  anonymousId,
  email,
  method,
  userId,
}: {
  anonymousId: ID;
  email: string;
  method: SignUpMethod;
  userId?: number;
}) {
  const response = await analytics.identify(userId?.toString(), { email });
  if (response) {
    analytics.track('Sign Up', {
      anonymousId,
      email,
      method,
    });
  }
}

export function fireOtpSubmitted({
  anonymousId,
  email,
  valid,
}: {
  anonymousId: string;
  email: string;
  valid: boolean;
}) {
  analytics.track('OTP Submitted', {
    anonymousId,
    email,
    valid,
  });
}

export function fireSocialAuthFailed({ anonymousId, provider }: { anonymousId: string; provider: string }) {
  analytics.track('Social Auth Failed', {
    anonymousId,
    provider,
  });
}

export function fireViewedSignup(anonymousId: ID) {
  analytics.track(SIGNUP_ACTIONED_EVENT, { anonymousId, action: 'viewed' });
}
